export const settingState = {
    loading: false,
    setting: null,
    error: false,
  };
  